import { type PropertyCard } from '@resolute/schema';
import { useQuery } from '@tanstack/react-query';


import { getData } from '@/lib/api-client';

const propertyKeys = {
  all: ['properties'] as const,
  featured: (limit: number) => [...propertyKeys.all, 'featured', limit] as const,
};

/** Curated, verified listings for the home page. */
export function useFeaturedProperties(limit = 6) {
  return useQuery({
    queryKey: propertyKeys.featured(limit),
    queryFn: () => getData<PropertyCard[]>('/properties/featured', { limit }),
  });
}
